import { withHTMLHeadSEO } from 'components/common';
import ClinicalEntryPoint from 'components/features/student-assignment-entry-point/ClinicalEntryPoint';

const ClinicalEntryPointPage = () => <ClinicalEntryPoint />;

export { ClinicalEntryPointPage as BaseClinicalEntryPointPage };
export default withHTMLHeadSEO({ title: 'Started Page' })(ClinicalEntryPointPage);
